import Model, { encoders, ID, Integer } from 'src/models/model'
import Movie from 'src/models/movie/Movie'
import PlanElement from 'src/models/schedule/PlanElement'

export default class BookingWeekMovie extends Model {
  static name = 'BookingWeekMovie'

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.FilmProgramming]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      movie: {
        type: Movie,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      planElement: {
        type: PlanElement,
        output: true,
        reference: true
      },
      priorityOrder: {
        type: Integer,
        default: 0
      },
      terms: {
        type: Number,
        default: null
      },
      siteApprovedPlan: {
        type: Boolean,
        default: false
      },
      siteApprovedLayout: {
        type: Boolean,
        default: false
      },
      siteApprovedSchedule: {
        type: Boolean,
        default: false
      }
    }
  }

  get description () {
    return `${this.planElement.name} - ${this.movie?.id || this.id}`
  }
}
